import { render, staticRenderFns } from "./declarationStatusQuery.vue?vue&type=template&id=bfb9681c&scoped=true&"
import script from "./declarationStatusQuery.vue?vue&type=script&lang=js&"
export * from "./declarationStatusQuery.vue?vue&type=script&lang=js&"
import style0 from "./declarationStatusQuery.vue?vue&type=style&index=0&id=bfb9681c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb9681c",
  null
  
)

export default component.exports